import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import isEmpty from "lodash/isEmpty";
import SectionContainer from "../../../components/sectionContainer/sectionContainer";
import TopPerformers from "./smartComponents/topPerformers";
import PoorPerformers from "./smartComponents/poorPerformers";
import ClassByType from "./smartComponents/classByType";
import NewCustomers from "./smartComponents/newCustomers";
import ExistingCustomers from "./smartComponents/existingCustomers";
import { actionCreators } from "./redux/sagas/attendance/attendance";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import { isModuleActive } from "../../../utils/modules";
import { configuratorStore } from "../dashboardConfigurator/dashboard";
import { configuratorMonthSwitcherStore } from "../monthSwitcherModule/monthSwitcher";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";

// const HEIGHT = 800;
export class AttendanceModule extends React.Component {
  state = {
    initRequest: false
  };

  componentDidMount() {
    if (isModuleActive(this.props.currentUser.dashboardPreferences, "Attendance")) {
      this.props.fetchCurrentUser({ user: this.props.currentUser });
      this.setState({
        initRequest: true
      });
    }

    // Dashboard configurator store
    configuratorStore.subscribe(() => {
      let state = configuratorStore.getState();

      if (
        isModuleActive(state.dashboardConfigurator.preferences, "Attendance") &&
        !this.state.initRequest
      ) {
        const { monthSwitcher } = configuratorMonthSwitcherStore.getState();

        this.props.fetchCurrentUser({ user: this.props.currentUser, date: monthSwitcher.date });
        this.setState({
          initRequest: true
        });
      }
    });

    // Month switcher store
    let previousDate;
    configuratorMonthSwitcherStore.subscribe(() => {
      if (this.state.initRequest) {
        const currentDate = configuratorMonthSwitcherStore.getState().monthSwitcher.date;

        if (currentDate !== previousDate) {
          previousDate = currentDate;
          this.props.updateAllData(currentDate);
        }
      }
    });
  }

  content() {
    if (this.props.isLoading) {
      return <LoadingAnimation />;
    }

    let { topPerformers, poorPerformers, newVisits, existingVisits } = this.props;
    return !isEmpty(topPerformers) ||
      !isEmpty(poorPerformers) ||
      newVisits > 0 ||
      existingVisits > 0 ? (
      <>
        <div className="section-group ">
          {/*If topPerformers array exists, iterate through it*/}
          {!isEmpty(topPerformers) ? (
            <SectionContainer title="Top Performers" toolTip="Ranked by Class Attendance">
              {topPerformers.map((_, index) => {
                return (
                  <span className="width-50" key={index}>
                    <TopPerformers index={index} topPerformer />
                  </span>
                );
              })}
            </SectionContainer>
          ) : (
            <div className="error">No data for top performers</div>
          )}

          {/*If poorPerformers array exists, iterate through it*/}
          {!isEmpty(poorPerformers) ? (
            <SectionContainer title="Poor Performers">
              {poorPerformers.map((_, index) => {
                return (
                  <span className="width-50" key={index}>
                    <PoorPerformers index={index} />
                  </span>
                );
              })}
            </SectionContainer>
          ) : (
            <p className="error">No data for poor performers</p>
          )}
        </div>
        <div className="section-group padding">
          <SectionContainer customStyles="padding-bottom" title="Class By Type Attendance">
            <ClassByType />
          </SectionContainer>
          {newVisits > 0 || existingVisits > 0 ? (
            <SectionContainer customStyles="no-padding" title="Active Clients">
              <div className="donut-wrapper">
                <NewCustomers />
              </div>
              <div className="donut-wrapper">
                <ExistingCustomers />
              </div>
            </SectionContainer>
          ) : (
            <div className="error">No data for active clients</div>
          )}
        </div>
      </>
    ) : (
      <div className="error error--big">No data for selected date range</div>
    );
  }

  render() {
    return (
      <SectionToggle
        title="Attendance"
        autoHeight
        isLoading={this.props.isLoading}
        maxHeight={800}
        content={this.content()}
      />
    );
  }
}

export default connect(
  state => ({
    topPerformers: state.attendance.topPerformers,
    poorPerformers: state.attendance.poorPerformers,
    isLoading: state.attendance.isLoading,
    userParams: state.attendance.currentUser,
    newVisits: state.attendance.visitsByType.newVisits,
    existingVisits: state.attendance.visitsByType.existingVisits
  }),
  {
    fetchCurrentUser: actionCreators.fetchCurrentUser,
    updateAllData: actionCreators.updateAllData
  }
)(AttendanceModule);

AttendanceModule.propTypes = { 
  fetchCurrentUser: PropTypes.func.isRequired,
  updateAllData: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  currentUser: PropTypes.object,
  topPerformers: PropTypes.array,
  poorPerformers: PropTypes.array,
  newVisits: PropTypes.number,
  existingVisits: PropTypes.number
};
